define.alias("shared/components/shared/post/secondary/caption-writer/footer", "media/components/shared/post/secondary/caption-writer/footer");